import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Check } from 'lucide-react';
interface AuthLayoutProps {
  children: ReactNode;
}
export function AuthLayout(t0) {
  const $ = _c(12);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-0 bg-gradient-to-br from-primary-surface to-primary-surface/80" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="/" className="flex items-center gap-3 mb-8 hover:opacity-90 transition-opacity"><Image src="/LeadsMiner white and grey.svg" alt="LeadsMiner" width={170} height={32} className="h-12 w-auto" priority={true} /></Link>;
    t3 = <h1 className="text-4xl xl:text-5xl font-bold text-white mb-6 leading-tight">Start Generating leads today</h1>;
    t4 = <p className="text-lg text-white/90 max-w-md mb-8">Get high quality leads with a simple monthly subscription — no ads required.</p>;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <li className="flex items-start gap-3"><div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-4 h-4 text-white" /></div><span className="text-white/90">Filter by industry, title, seniority, and company size</span></li>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li className="flex items-start gap-3"><div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-4 h-4 text-white" /></div><span className="text-white/90">Verified emails and direct dials for decision-makers</span></li>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <li className="flex items-start gap-3"><div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-4 h-4 text-white" /></div><span className="text-white/90">Export to CSV — ready for your CRM or sender</span></li>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="hidden lg:flex lg:w-1/2 bg-primary-surface relative overflow-hidden">{t1}<div className="relative z-10 flex flex-col justify-center px-12 xl:px-20">{t2}{t3}{t4}<ul className="space-y-4">{t5}{t6}{t7}<li className="flex items-start gap-3"><div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-4 h-4 text-white" /></div><span className="text-white/90">Unlimited searches and contact lists</span></li></ul></div><div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl" /><div className="absolute top-20 right-20 w-64 h-64 bg-white/5 rounded-full blur-2xl" /></div>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="absolute inset-0 lg:hidden"><div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl" /><div className="absolute top-20 right-20 w-64 h-64 bg-white/5 rounded-full blur-2xl" /></div>;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="lg:hidden text-center mb-8"><Link href="/" className="flex items-center justify-center mb-6 hover:opacity-90 transition-opacity"><Image src="/LeadsMiner white and grey.svg" alt="LeadsMiner" width={170} height={32} className="h-10 w-auto" priority={true} /></Link><h1 className="text-2xl sm:text-3xl font-bold text-white leading-tight px-4">Start Generating leads today</h1></div>;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== children) {
    t11 = <div className="min-h-screen flex flex-col"><div className="flex flex-1">{t8}<div className="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-12 bg-background lg:bg-background bg-primary-surface lg:bg-background relative overflow-hidden">{t9}<div className="w-full max-w-md relative z-10">{t10}<div className="lg:bg-transparent bg-white rounded-2xl lg:rounded-none shadow-xl lg:shadow-none p-6 sm:p-8 lg:p-0">{children}</div></div></div></div></div>;
    $[10] = children;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
}